module.exports = __webpack_public_path__ + "img/l-header-bg-new.dc497fa3.png";